import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface AddContactModalProps {
  readonly open: boolean;
  readonly isAdding: boolean;
  readonly onClose: () => void;
  readonly onAdd: () => Promise<void>;
}

function AddContactModal({
  open,
  isAdding,
  onClose,
  onAdd,
}: AddContactModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box className="flex items-center gap-2">Add Contact</Box>
      </DialogTitle>
      <DialogContent>
        <Box className="space-y-4">
          <Typography variant="body1">
            Add this person’s information to your contacts for future use?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={isAdding} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={isAdding}
          onClick={onAdd}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddContactModal;
